import React from 'react';

import { FormInstance, Divider } from 'antd';
import {
  Input,
} from 'UI';

import {
  FormContainer,
  NameInputFormItem,
  AddButton,
} from './style';

export interface AddCultureFormData {
  name: string
}

interface AddCultureFormProps {
  formHandler: FormInstance
  onSubmit(data: unknown): void
  isLoading?: boolean
}

const AddCultureForm = ({
  formHandler,
  onSubmit,
  isLoading,
}: AddCultureFormProps): JSX.Element => (
  <>
    <Divider />
    <FormContainer
      layout="vertical"
      form={formHandler}
      requiredMark={false}
      onFinish={onSubmit as (val: unknown) => void}
    >
      <NameInputFormItem
        name="name"
        rules={[
          {
            required: true,
            message: 'Insira um nome',
          },
        ]}
      >
        <Input name="name" disabled={isLoading} />
      </NameInputFormItem>
      <AddButton htmlType="submit" loading={isLoading}>Criar cultura</AddButton>
    </FormContainer>
  </>
);

AddCultureForm.defaultProps = {
  isLoading: false,
};

export default AddCultureForm;
